<template>
	<div>

	</div>
</template>

<script>
    import promotionItem from '@/components/promotion/item';

    export default {
        name: 'promoSlide',
        components: { promotionItem },
	    props: {
            col: {
                default: '6'
            },
		    part: {
                default: 2
		    }
	    },
        data () {
            return {
                t: this.$root.t,
                promotions: null,
                session:  this.$root.session,
                selectedPromotion: 0
            }
        },
        watch: {
            '$root.session' () {
                this.session = this.$root.session
                this.fetchPromotions();
            },
        },
        mounted () {
            this.fetchPromotions();
        },
        methods:
            {
                fetchPromotions () {
                    this.$http.get(api+'api/v1/promotions').then(response => {

                        if (response.body.promotions) {
                            this.promotions = this.partition(response.body.promotions, this.part);
                        }

                    }, response => {
                        // error callback
                    });
                },
                openPromotion (pid) {
                    this.selectedPromotion = pid;
                    this.$refs.promotionModal.open();

                },
            }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/promotion/promoSlide.vue